import Echo from 'laravel-echo';

import Pusher from 'pusher-js';

export const setupEcho = async (token: string) => {
  // @ts-ignore
  if (window.Pusher === undefined) {
    // @ts-ignore
    window.Pusher = Pusher;
  }

  // @ts-ignore
  if (window.Echo === undefined) {
    // @ts-ignore
    window.Echo = new Echo({
      broadcaster: 'reverb',
      key: process.env.REACT_APP_REVERB_APP_KEY,
      wsHost: process.env.REACT_APP_REVERB_HOST,
      wsPort: process.env.REACT_APP_REVERB_PORT,
      wssPort: process.env.REACT_APP_REVERB_PORT,
      forceTLS: (process.env.REACT_APP_REVERB_SCHEME ?? 'https') === 'https',
      enabledTransports: ['ws', 'wss'],
      disableStats: true,
      encrypted: false,
      // Critical: Disable compression to avoid RSV1 error
      wsOptions: {
        perMessageDeflate: false,
      },
      authEndpoint: process.env.REACT_APP_REVERB_SERVER_URL + '/broadcasting/auth',
      auth: {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          client_id: process.env.REACT_APP_REVERB_APP_ID,
          client_secret: process.env.REACT_APP_REVERB_APP_SECRET,
        },
      },
    });
  }
};
